module.exports = __webpack_public_path__ + "assets/f1282604f9d5df17eab87544c465d338.png";